"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var badge_1 = __importDefault(require("./badge"));
exports.default = badge_1.default;
__export(require("./badge"));
//# sourceMappingURL=index.js.map